import * as React from 'react';
import { useState } from 'react';
import { SiteListItem, ModifiableSiteStatus, editableSiteStatus } from '../../../services/company/companyModels';
import { InviteUserModal } from './inviteUserModal';
import { AdminRequestType } from '../systemAdmin/models';

export function CompanySiteTable(props: CompanySiteTableProps): JSX.Element {
  const { companySites, companyId, companyName, forManageSites, requestType } = props;
  return <>
    {
      companySites.length
        ? companySites.map((site, idx) => (
          <SiteRow
            key={idx}
            site={site}
            forManageSites={forManageSites}
            companyId={companyId}
            companyName={companyName}
            requestType={requestType}
          />
        ))
        : <tr>
          <td colSpan={7}>No sites</td>
        </tr>
    }
  </>;
}

export function SiteRow(props: SiteRowProps): JSX.Element {
  const { site, requestType, forManageSites } = props;
  const [siteStatus, setSiteStatus] = useState(site.status);
  const [addSiteUser, setAddSiteUser] = useState<boolean>(false);

  return (
    <tr className={props.isFirstRow ? 'first-site-row' : ''}>
      {
        forManageSites && props.isFirstRow === true
          ?
          <td rowSpan={props.totalCompanySites}>
            <a href={`/${requestType}/company/${props.companyId}`}>
              {props.companyName}
            </a>
          </td>
          : <></>
      }
      <td>{site.name}</td>
      <td>{site.state}</td>
      <td>{site.type}</td>
      <td>{new Date(site.createdAt).toDateString()}</td>
      <td className='admin-user-count' tabIndex={0}>
        <div className='dropdown is-hoverable'>
          <div className='dropdown-trigger'>
            <button
              className='button is-small is-clickable'
              disabled={site.siteUsers.length === 0}
              aria-haspopup='true'
              aria-controls='dropdown-menu4'
            >
              <span>{site.siteUsers.length}</span>
            </button>
          </div>
          {
            site.siteUsers.length > 0
              ? <div className='dropdown-menu' id='dropdown-menu4' role='menu'>
                <div className='dropdown-content'>
                  {
                    site.siteUsers.map((user, idx) => <div key={idx} className='dropdown-item'>
                      <a
                        href={`/${requestType}/user/${user.userId}`}
                      >
                        {`${user.name} (${user.roles[0]})`}
                      </a>
                    </div>)
                  }
                </div>
              </div>
              : <></>
          }
        </div>
      </td>
      <td>
        <div className='select is-small'>
          <select
            name={`siteId_${site.siteId}`}
            value={siteStatus}
            onChange={(evt) => {
              const status = evt.currentTarget.value as ModifiableSiteStatus;
              if (props.onSiteStatusChange) {
                props.onSiteStatusChange(status);
              }
              setSiteStatus(status);
            }}
            disabled={props.saving}
          >
            {
              editableSiteStatus.map(status => <option key={status} value={status} className='is-capitalized'>
                {status}
              </option>  
              )
            }
          </select>
        </div>
      </td>
      {
        forManageSites
          ? <td>
            <input
              className="input is-small"
              value={site.memberId}
              onChange={(evt) => { if (props.onMemberIdChange) { props.onMemberIdChange(evt.currentTarget.value); } }}
              disabled={props.saving}
            />
          </td>
          : <></>
      }
      <td>
        <button
          className='button is-link is-small'
          type='button'
          onClick={() => setAddSiteUser(true)}
        >
          Add User
        </button>
        {
          addSiteUser &&
          <InviteUserModal
            companyId={props.companyId}
            site={site}
            onCancel={() => setAddSiteUser(false)}
            redirectUrl={window.location.href}
            requestType={requestType}
          />
        }
      </td>
    </tr>
  );

}

type CompanySiteTableProps = {
  companyId: number;
  companyName: string;
  companySites: SiteListItem[];
  requestType: AdminRequestType;
  forManageSites: boolean;
};

type SiteRowProps = {
  companyId: number;
  companyName: string;
  site: SiteListItem;
  forManageSites: boolean;
  totalCompanySites?: number;
  onSiteStatusChange?: (siteStatus: ModifiableSiteStatus) => void;
  onMemberIdChange?: (id: string) => void;
  saving?: boolean;
  isFirstRow?: boolean;
  requestType: AdminRequestType;
};